// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-big-calendar/lib/css/react-big-calendar.css
// module id = 1899
// module chunks = 1